import { render, staticRenderFns } from "./CustomDialogShowTree.vue?vue&type=template&id=628df890&scoped=true&"
import script from "./CustomDialogShowTree.vue?vue&type=script&lang=js&"
export * from "./CustomDialogShowTree.vue?vue&type=script&lang=js&"
import style0 from "./CustomDialogShowTree.vue?vue&type=style&index=0&id=628df890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628df890",
  null
  
)

export default component.exports